import { CircleDollarSign } from 'lucide-react'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import CostEventsTable from './components/CostEventsTable'
import CostFilters from './components/CostFilters'
import CostSummary from './components/CostSummary'
import ImportRunsPanel from './components/ImportRunsPanel'
import type { CostEvent, CostFilters as Filters, CostSummary as Summary, ImportRun, Pagination } from './types'

interface Props {
  summary: Summary
  events: CostEvent[]
  pagination: Pagination
  filters: Filters
  search: string
  dateFrom: string
  dateTo: string
  organizationId: string
  digitalWorkerId: string
  model: string
  status: string
  importRuns: ImportRun[]
}

function LitellmCostsIndex(props: Props) {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <CircleDollarSign className="h-6 w-6 text-foreground" />
        <h2 className="text-2xl font-bold text-foreground">Custos IA</h2>
      </div>

      <CostSummary summary={props.summary} />

      <CostFilters
        filters={props.filters}
        search={props.search}
        dateFrom={props.dateFrom}
        dateTo={props.dateTo}
        organizationId={props.organizationId}
        digitalWorkerId={props.digitalWorkerId}
        model={props.model}
        status={props.status}
      />

      <CostEventsTable events={props.events} pagination={props.pagination} />
      <ImportRunsPanel importRuns={props.importRuns} />
    </div>
  )
}

LitellmCostsIndex.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>

export default LitellmCostsIndex
